import React from 'react';
import { SvgIcon } from './utils/SvgIcon.js';
import type { SvgIconT } from './utils/react-desc-prop-types.js';

const CloseCircleFillMed = (props: SvgIconT.Props) => (
  <SvgIcon width={24} height={24} {...props} viewBox="0 0 24 24">
    <path
      d="M12 2c5.524 0 10 4.476 10 10s-4.476 10-10 10S2 17.524 2 12 6.476 2 12 2Zm3.646 5.646L12 11.293 8.354 7.646l-.708.708L11.293 12l-3.647 3.646.708.708L12 12.707l3.646 3.647.708-.708L12.707 12l3.647-3.646-.708-.708Z"
      fillRule="evenodd"
    />
  </SvgIcon>
);

export default CloseCircleFillMed;
